import React from 'react';
import * as Yup from 'yup';
import AuthBtnSpinner from '../../utils/AuthBtnSpinner';
import { Field, Form, Formik } from 'formik';
import { MobileSendOtp } from '../../api';
import { CustomInputComponent } from '../../components/formik/FieldComponents';
import { toast } from 'react-toastify';
import { useState } from 'react';
import Cookies from "js-cookie";


const OTPValidationSchema = Yup.object().shape({
    mobile_number: Yup.string().required('Mobile number is required')
});

function VerifyMobile() {

    const [errorMsg,seterrorMsg] = useState(null);

    const { mutateAsync:sendOTP, isLoading } = MobileSendOtp();

    const userDetail = Cookies.get("userDetail")
    ? JSON.parse(Cookies.get("userDetail"))
    : {};

    return (

        <section className="mid-wrap pt-5 pb-5">
            <div className="mid-card-block">
                <div className="mxw-750">
                    {/* <div className="text-center mb-4 vendor-info">
                        <img src={logoVr} alt="my mandi" />
                    </div> */}
                    <h5 className="card-title lg-title mb-4 fw-700">Verify Mobile Number</h5>
                    <div className="card form-card">
                        <div className="card-body">
                            
                            <p className="sm-title mb-4 mt-3 fw-700 font-16">Enter the mobile number for OTP verification</p>

                            <Formik
                                initialValues={{
                                    mobile_number: Cookies.get("jwtMobileVerify")?Cookies.get("jwtMobileVerify"):userDetail.mob?userDetail.mob:'',
                                }}
                                validationSchema={OTPValidationSchema}
                                onSubmit={(values) => sendOTP(values,{
                                    onError: (error)=>{
                                        if (error.response) {
                                              let res = error.response.data;
                                              if (error.response.status === 403) {
                                                  //toast.error(res.message);
                                                  seterrorMsg(res.message);
                                                 // errors.email = res.message;
                                              }else{
                                                 toast.error(error.response.message);
                                              }
                                              if (error.response.status === 500) {
                                                  toast.error('Internal Server Error');
                                              }
                                          }
                                      }
                                })}
                                validateOnBlur={true}
                                validateOnChange={true}
                            >

                                {({ errors, touched }) => (

                                    // Contact Us Form
                                    <Form className="custom-form">
                                        <div className="form-group">
                                            <label>Mobile Number</label>
                                            <Field name="mobile_number" component={CustomInputComponent} type="text" className="form-control" />
                                           
                                           {/* onChange={() => { seterrorMsg(null) } } */ }
                                           
                                            {seterrorMsg && !errors.mobile_number && (
                                                <small className='text-danger'>                                                   
                                                     {errorMsg}
                                                </small>
                                            )}
                                      
                                        </div>
                                        {isLoading ? (
                                             <AuthBtnSpinner />
                                        ) : (
                                            <button className='theme-btn btn w-100' type='submit'>
                                                Next
                                            </button>
                                        )}
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )

}

export default VerifyMobile